<template>
  <div class="home">
    <HeaderComp/>
    <Formatos/>
    <Embajadoras/>
    <Premios/>
    <!--<brackets>-->
    <FormComp/>
    <GoogleMap/>
    <FooterComp/>
  </div>
</template>

<script>
import HeaderComp from "../components/Header.vue";
import Formatos from "@/components/Formatos.vue";
import Embajadoras from "@/components/Embajadoras.vue";
import Premios from "@/components/Premios.vue";
import FooterComp from "@/components/Footer.vue";
import FormComp from "@/components/Form.vue";
import GoogleMap from "@/components/GoogleMap.vue";
import brackets from "@/components/Brackets";
export default {
    name: "HomeView",
    components: { HeaderComp, Formatos, Embajadoras, Premios, FooterComp, FormComp, GoogleMap, brackets}
}
</script>
